import React, { useContext } from "react";
import DataContext from "../contexts/dataContext";
import { TaskBar, List } from "@react95/core";
import styled from "styled-components";

const Link = styled.a`
  text-decoration: none;
  color: inherit;
`;

function Taskbar() {
  const { test1, test2 } = useContext(DataContext).getProjectInfo();
  // console.log(projectRepo, react95Repo)
  return (
    <TaskBar
      list={
        <List>
          <List.Item className="pointer" icon="brush">
            <Link href={test1} target="_blank">
              Test 1
            </Link>
          </List.Item>
          <List.Divider />
          <List.Item className="pointer" icon="folder_file">
            <Link href={test2} target="_blank">
              Test 2
            </Link>
          </List.Item>
        </List>
      }
    />
  );
}

export default Taskbar;
